var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.telefono
        ? _c("audios", { attrs: { uniqueid: _vm.uniqueid } })
        : _vm._e(),
      _vm._v(" "),
      _vm.whatsapp
        ? _c("reporte_whatsapp", { attrs: { uniqueid: _vm.uniqueid } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }